// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608071104/js/" + chunkId + "." + {"44":"2a9888ff","225":"fd30d535","481":"217de83e","486":"2de1f5a5","770":"8d4035f1"}[chunkId] + ".0.36141200791701855.chunk.js";
};